/**
 * @file
 * Attaches the behaviors for the main Menu component.
 */
!(function ($, Drupal) {
  'use strict';

  Drupal.behaviors.navToggle = {
    attach(context) {
      const self = this;

      once('navToggle', '.nav-toggle', context).forEach((navToggle, index) => {
        const $navToggle = $(navToggle);
        const $header = $navToggle.closest('.l-header');
        const $toggle = $navToggle.find('button');
        const $nav = $header.find('.l-header__navigation').first();

        // If there is no related header navigation, none of the code below
        // should execute.
        if (!$nav.length || !$toggle.length) {
          return;
        }

        const navId = $nav.attr('id') || `header-navigation-${index + 1}`;
        $nav.attr('id', navId);
        $toggle
          .attr('aria-controls', navId);

        const toggleNav = ($trigger) => {
          const isExpanded = $nav.hasClass('expanded');

          self.closeSearch();

          if (isExpanded) {
            setTimeout(() => {
              self.closeNav($nav, $trigger);
            }, 100);
          } else {
            setTimeout(() => {
              self.openNav($nav, $trigger);
            }, 100);
          }
        };

        const closeNavAndFocusToggle = () => {
          const isExpanded = $nav.hasClass('expanded');

          if (isExpanded) {
            self.closeNav($nav, $toggle);
          }

          $toggle.trigger('focus');
        };

        $toggle.on('click', function (e) {
          e.preventDefault();
          toggleNav($(this));
        });

        // Close menu with ESC key when pressed anywhere in the navigation.
        $nav.on('keydown', function (e) {
          const key = e.key ? e.key : '';
          const keyCode = e.keyCode ? e.keyCode : e.which;

          // ESC (27) should close the menu and return focus to toggle.
          if (key === 'Escape' || keyCode === 27) {
            e.preventDefault();
            e.stopPropagation();
            closeNavAndFocusToggle();
          }
        });

        $toggle.on('keydown', function (e) {
          const key = e.key ? e.key : '';
          const keyCode = e.keyCode ? e.keyCode : e.which;

          // ESC (27) should close the menu.
          // Enter/Space are intentionally handled by native button activation.
          if (key === 'Escape' || keyCode === 27) {
            e.preventDefault();
            closeNavAndFocusToggle();
          }
        });
      });
    },

    openNav($nav, $toggle) {
      $nav
        .addClass('expanded')
        .attr('aria-expanded', 'true');
      $toggle.attr('aria-expanded', 'true');
    },

    closeNav($nav, $toggle) {
      $nav
        .removeClass('expanded')
        .attr('aria-expanded', 'false');
      $toggle.attr('aria-expanded', 'false');
    },

    closeSearch(){
      const $search = $('.l-header__global-search');
      const state = $search.hasClass('expanded');
      const $nav = $('.l-header__navigation');

      if(state){
        $search
          .toggleClass('expanded', false)
          .attr('aria-expanded', 'false');
        $nav.find('.main-nav__menu-item').toggleClass('no-hover', false);
      }
      
    }
  };
})(jQuery, Drupal);
